const GetReportByGroup = (data) => {
  const list = {};
  for (const i in data) {
    const item = data[i];
    const rep_group_id = item.rep_group_id;
    if (!(rep_group_id in list)) {
      list[rep_group_id] = [];
    }
    list[rep_group_id].push(item);
  }
  return list;
};

const GetValueChangeEmployment = (id, name, value, filters) => {
  const index = parseInt(id.split(name + "_")[1]);
  let employments = [...filters.employment];
  if (index in employments) {
    employments[index][name] = value;
  }
  return ["employment", employments];
};

const GetValueChangePositionChange = (id, name, value, filters) => {
  const index = parseInt(id.split(name + "_")[1]);
  let position_changes = [...filters.position_change];
  if (index in position_changes) {
    const field =
      name === "position_change_job_title"
        ? "position"
        : name.replace("position_change_", "");
    position_changes[index][field] = value;
  }
  return ["position_change", position_changes];
};

const GetValueChangeIdentification = (id, name, value, filters, addon) => {
  const index = parseInt(id.split(name + "_")[1]);
  let identifications = [...filters.identification];
  if (index in identifications) {
    const field = name.replace("identification_", "");
    identifications[index][field] = value;
    if (field === "type" && value === "OT") {
      identifications[index]["name"] = "";
    } else if (field === "type" && value === "NR") {
      identifications[index]["name"] = addon?.name ?? "";
      identifications[index]["number"] = "";
      identifications[index]["expiration_date"] = "";
      identifications[index]["description"] = "";
      identifications[index]["link"] = "";
    } else if (field === "type" && addon?.name) {
      identifications[index]["name"] = addon.name;
    }
    identifications[index]["updated_date"] = new Date().toISOString();
  }
  // console.log(identifications);
  return ["identification", identifications];
};

const GetValueChangeUserGroup = (evt, filters) => {
  let value = evt.target.value;
  let user_groups = [...filters.user_group];
  if (evt.target.checked) {
    user_groups = [...filters.user_group, value];
  } else {
    user_groups.splice(filters.user_group.indexOf(value), 1);
  }
  return ["user_group", user_groups];
};

const GetValueChangeUserCountriesAccess = (data) => {
  let user_countries_accesses = [...data.filters.user_countries_access];
  if (data.checked) {
    user_countries_accesses = [
      ...data.filters.user_countries_access,
      data.value,
    ];
  } else {
    user_countries_accesses.splice(
      data.filters.user_countries_access.indexOf(data.value),
      1
    );
  }
  return ["user_countries_access", user_countries_accesses];
};

const GetValueChangeUserSalesOfficeAccess = (evt, filters) => {
  let user_sales_office_accesses = [...filters.user_sales_office_access];
  if (evt.target.checked) {
    user_sales_office_accesses = [
      ...filters.user_sales_office_access,
      parseInt(evt.target.value),
    ];
  } else {
    user_sales_office_accesses.splice(
      filters.user_sales_office_access.indexOf(parseInt(evt.target.value)),
      1
    );
  }
  return ["user_sales_office_access", user_sales_office_accesses];
};

const GetValueChangeReportCountries = (evt, filters) => {
  let report_countries = { ...filters.report_countries };
  const repId = evt.target.getAttribute("repid");
  const countryId = evt.target.value;
  // console.log("1.Change report_countries => ", report_countries, countryId);
  if (evt.target.checked) {
    if (report_countries?.[repId] === undefined) {
      report_countries[repId] = {};
    }
    if (report_countries?.[repId]?.[countryId] === undefined) {
      report_countries[repId][countryId] = {};
    }
    if (report_countries?.[repId]?.[-1]) {
      delete report_countries[repId][-1];
    }
    report_countries[repId][countryId] = 1;
  } else {
    if (report_countries?.[repId]?.[countryId]) {
      delete report_countries[repId][countryId];
    }
    if (report_countries?.[repId]?.[-1]) {
      delete report_countries[repId][-1];
    }
    if (
      report_countries?.[repId] &&
      Object.keys(report_countries[repId]).length === 0
    ) {
      delete report_countries[repId];
    }
  }
  // console.log("2.Change report_countries => ", report_countries);
  return ["report_countries", report_countries];
};

const GetValueChangeUserReportsAccess = (data) => {
  let user_reports_accesses = [...data.filters.user_reports_access];
  if (data.checked) {
    user_reports_accesses = [
      ...data.filters.user_reports_access,
      parseInt(data.value),
    ];
  } else {
    user_reports_accesses.splice(
      data.filters.user_reports_access.indexOf(parseInt(data.value)),
      1
    );
    if (data.filters?.report_countries?.[parseInt(data.value)]) {
      delete data.filters.report_countries[parseInt(data.value)];
    }
  }
  // console.log("Change user_report_access => ", user_reports_accesses);
  // console.log("Change report_countries => ", data.filters.report_countries);
  return ["user_reports_access", user_reports_accesses];
};

const GetValueChangeUserGroupReportsAccess = (data) => {
  const rep_group_id = data.value;
  const user_reports_accesses = [...data.filters.user_reports_access];
  const user_group_relate_report = [...data.filters.user_group_relate_report];
  const rep_data = [...data.filterData.data.rep_data_by_group[rep_group_id]];
  if (data.checked) {
    for (const i in rep_data) {
      const item = rep_data[i];
      const rep_id = parseInt(item.rep_id);
      if (user_reports_accesses.indexOf(rep_id) >= 0) {
        continue;
      }
      if (user_group_relate_report.indexOf(rep_id + "") >= 0) {
        continue;
      }
      user_reports_accesses.push(rep_id);
    }
  } else {
    for (const i in rep_data) {
      const item = rep_data[i];
      const rep_id = parseInt(item.rep_id);
      if (user_reports_accesses.indexOf(rep_id) < 0) {
        continue;
      }
      if (user_group_relate_report.indexOf(rep_id + "") >= 0) {
        continue;
      }
      user_reports_accesses.splice(user_reports_accesses.indexOf(rep_id), 1);
    }
  }
  // console.log("Change user_group_report_access => ", user_reports_accesses);
  return ["user_reports_access", user_reports_accesses];
};

const CheckedRequired = (filters) => {
  const elems = document.querySelectorAll('[data-required="true"]');
  const n = elems.length;
  let checked = true;
  for (let i = 0; i < n; i++) {
    //if (!checked) continue;
    const name = elems[i].getAttribute("name");
    const multiple = elems[i].getAttribute("multiple");
    //console.log(name, filters);
    if (name === "employment_type") {
      if (
        filters?.employment &&
        filters?.employment.length > 0 &&
        filters?.employment?.[0].employment_type !== ""
      ) {
        continue;
      } else {
        checked = false;
      }
    } else if (name === "start_date") {
      if (
        filters?.employment &&
        filters?.employment.length > 0 &&
        filters?.employment?.[0].start_date !== ""
      ) {
        continue;
      } else {
        checked = false;
      }
    } else if (name === "identification_expiration_date") {
      const id = elems[i].getAttribute("id") ?? "";
      const index = parseInt(id.split(name + "_")[1]);
      if (
        !isNaN(index) &&
        filters?.identification &&
        filters.identification[index]?.expiration_date
      ) {
        continue;
      } else {
        checked = false;
      }
    } else if (filters?.[name] === undefined) {
      checked = false;
    } else if (
      multiple !== null &&
      filters?.[name] &&
      filters?.[name].length === 0
    ) {
      checked = false;
    } else if (filters[name] === "") {
      checked = false;
    }
  }
  return checked;
};

const GetDepartmentsAfterChanged = (filters, organizations, departments) => {
  let mergedArray = [];
  for (const i in organizations) {
    const orgID = organizations[i];
    if (filters?.[orgID]) {
      const dept_ids = filters[orgID].map((item) => item.dept_id);
      mergedArray = [...mergedArray, ...dept_ids];
    }
  }
  // console.log("mergedArray =", mergedArray );
  let data = [];
  if (departments?.length > 0) {
    for (const i in departments) {
      const deptID = departments[i];
      const isFound = mergedArray.includes(deptID);
      if (isFound) {
        data.push(deptID);
      }
    }
  }
  // console.log("data=", data);
  return data;
};

const GetDivisionsAfterChanged = (filters, departments, divisions) => {
  let mergedArray = [];
  for (const i in departments) {
    const deptID = departments[i];
    if (filters?.[deptID]) {
      const division_ids = filters[deptID].map((item) => item.dept_id);
      mergedArray = [...mergedArray, ...division_ids];
    }
  }
  // console.log("mergedArray =", mergedArray );
  let data = [];
  if (divisions?.length > 0) {
    for (const i in divisions) {
      const deptID = divisions[i];
      const isFound = mergedArray.includes(deptID);
      if (isFound) {
        data.push(deptID);
      }
    }
  }
  // console.log("data=", data);
  return data;
};

export {
  GetReportByGroup,
  GetValueChangeEmployment,
  GetValueChangePositionChange,
  GetValueChangeIdentification,
  GetValueChangeUserGroup,
  GetValueChangeUserCountriesAccess,
  GetValueChangeUserSalesOfficeAccess,
  GetValueChangeReportCountries,
  GetValueChangeUserReportsAccess,
  GetValueChangeUserGroupReportsAccess,
  CheckedRequired,
  GetDepartmentsAfterChanged,
  GetDivisionsAfterChanged,
};
